/**
 * @generated SignedSource<<ff50d48748c63ec4cdd5bb639c59dda0>>
 * @relayHash 6d398f53c96bfaf582af7d85174c1481
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8f4bcff577614f0cd50804d51d1a52bedfe13340434f25cdb870ac70f0d0576

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSpaceOwnerType = "GROUP" | "USER" | "%future added value";
export type useSpaceContributorsSpaceRolesQuery$variables = {
  first?: number | null;
  spaceId: string;
};
export type useSpaceContributorsSpaceRolesQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly spaceAdmins: {
      readonly nodes: ReadonlyArray<{
        readonly __typename: "KnownUser";
        readonly accountId: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null> | null;
    };
    readonly spaceOwner: {
      readonly ownerId: string | null;
      readonly ownerType: ConfluenceSpaceOwnerType | null;
    } | null;
  } | null;
};
export type useSpaceContributorsSpaceRolesQuery = {
  response: useSpaceContributorsSpaceRolesQuery$data;
  variables: useSpaceContributorsSpaceRolesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "spaceId"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceSpaceDetailsSpaceOwner",
        "kind": "LinkedField",
        "name": "spaceOwner",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ownerId"
          },
          {
            "kind": "ScalarField",
            "name": "ownerType"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "excludeAddOns",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "spaceAdmins",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  }
                ],
                "type": "KnownUser"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceContributorsSpaceRolesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceContributorsSpaceRolesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6d398f53c96bfaf582af7d85174c1481",
    "id": "b8f4bcff577614f0cd50804d51d1a52bedfe13340434f25cdb870ac70f0d0576",
    "metadata": {},
    "name": "useSpaceContributorsSpaceRolesQuery",
    "operationKind": "query",
    "text": "query useSpaceContributorsSpaceRolesQuery($spaceId:ID!,$first:Int){space(id:$spaceId){id,spaceOwner{ownerId,ownerType},spaceAdmins(first:$first,excludeAddOns:true){nodes{__typename,...on KnownUser{accountId}}}}}"
  }
};
})();

(node as any).hash = "70920be3ede0d2e90eadf91c05d60d4d";

export default node;
